import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { loadCurrentOrganisation } from '@redux/directChildOrganisationAdministration/actions';
import {
  ParentOrganisationCapabilityLoading,
  useParentOrganisationCapabilityBootstrap,
} from './ParentOrganisationCapability';

const DirectChildOrganisationAdministrationGuard = ({ children }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const {
    currentOrganisation,
    hasParentOrganisationCapability,
  } = useParentOrganisationCapabilityBootstrap();

  if (currentOrganisation.status === 'idle' || currentOrganisation.status === 'loading') {
    return <ParentOrganisationCapabilityLoading />;
  }

  if (currentOrganisation.status === 'failure') {
    return (
      <section role="alert">
        <h1>{t('directChildOrganisationAdministration:capability.failureTitle')}</h1>
        <p>{t('directChildOrganisationAdministration:capability.failureDescription')}</p>
        <button type="button" onClick={() => dispatch(loadCurrentOrganisation())}>
          {t('directChildOrganisationAdministration:capability.retry')}
        </button>
      </section>
    );
  }

  if (!hasParentOrganisationCapability) {
    return <Redirect to="/administration" />;
  }

  return children;
};

DirectChildOrganisationAdministrationGuard.propTypes = {
  children: PropTypes.node.isRequired,
};

export default DirectChildOrganisationAdministrationGuard;
